module.exports = __webpack_public_path__ + "media/images/country_flags/lk-0de280d1414f4c2942dcb5424685a455.png";